import React from 'react';
import PropTypes from 'prop-types';

const ModuleHeader = ({ header, divider }) => (
  <div className="module-header row mb-3-md">
    <div className="col-12 col-lg-5">
      <h2 className="headline">{header}</h2>
      { divider && <hr className="mini-divider my-3 stick-left" /> }
    </div>
  </div>
);

ModuleHeader.defaultProps = {
  divider: false,
};

ModuleHeader.propTypes = {
  header: PropTypes.string.isRequired,
  divider: PropTypes.bool,
};

export default ModuleHeader;
